'use client';

import { UTM_KEYS } from '@/app/constants';
import { useEffect } from 'react';

export const StoreUTM = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const keys = [...searchParams.keys()];
    const urlHasUTM = keys.some((key) => key.toLowerCase().startsWith('utm'));

    UTM_KEYS.forEach((key) => {
      const valueFromUrl = searchParams.get(key);
      const existing = sessionStorage.getItem(key);

      if (urlHasUTM) {
        if (existing) {
          sessionStorage.removeItem(key);
        }
        if (valueFromUrl) {
          sessionStorage.setItem(key, valueFromUrl);
        }
      } else {
        if (valueFromUrl && (!existing || existing !== valueFromUrl)) {
          sessionStorage.setItem(key, valueFromUrl);
        }
      }
    });
  }, []);

  return null;
};
